"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tline-height: ", ";\n\tfont-size: ", ";\n\tfont-family: ", " !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var PickerSeparator = _styledComponents.default.div(_templateObject(), _spacing.default.s11, _spacing.default.s5, _vars.default.fontStackNormal);

PickerSeparator.displayName = 'PickerSeparator';
/** @component */

var _default = PickerSeparator;
exports.default = _default;